/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import COLORS from 'common/stylesheets/mixins/colors.json';

import {Section, SubSection} from './utils';

function colorPalette(colorGroups) {
  return (
    <div sel='.item-palette'>
      {colorGroups.map((colorGroup) => (
        <div sel='.example'>
          {colorGroup.map((color) => (
            <div sel='.list-block'>
              <div sel='.color' style={{'background-color': COLORS[color]}} />
              <div sel='.color-label'>{COLORS[color]}</div>
              <div sel='.label'>{color}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export function ColorsSection() {
  return (
    <Section title='Colors'>
      <SubSection title='Gray Palette'>
        <p sel='.desc'>
          Our gray palette features three AA compliant contrast ratios and should be used for text across product. Only
          use gray2 and gray1 for decorative elements.
        </p>
        {colorPalette([[`$gray1`, `$gray2`, `$gray3`, `$gray4`, `$gray5`], [`$white`]])}
      </SubSection>

      <SubSection title='Color Palette'>
        <p sel='.desc'>
          Our color usage is comprised of blue, red, orange, and green. Please reserve 2, 3, variants for states on
          primary buttons (e.g. blue2: hover, blue3: pressed). All colors comply with AA standard contrast ratios.
        </p>
        {colorPalette([
          [`$blue1`, `$blue2`, `$blue3`],
          [`$orange1`, `$orange2`, `$orange3`],
        ])}
        {colorPalette([
          [`$red1`, `$red2`, `$red3`],
          [`$green1`, `$green2`, `$green3`],
        ])}
      </SubSection>

      <SubSection title='Data Visualization Palette'>
        <p sel='.desc'>
          Our data visualization colors are arranged in two groups: chart colors and scales. Scale colors are reserved
          for usage in Retention and Signal only, please do not pull from these colors in your designs.
        </p>
        {colorPalette([
          [
            `$chart1`,
            `$chart2`,
            `$chart3`,
            `$chart4`,
            `$chart5`,
            `$chart6`,
            `$chart7`,
            `$chart8`,
            `$chart9`,
            `$chart10`,
            `$chart11`,
            `$chart12`,
          ],
          [`$highlight-color`],
        ])}
        {colorPalette([
          [
            `$positive-scale0`,
            `$positive-scale1`,
            `$positive-scale2`,
            `$positive-scale3`,
            `$positive-scale4`,
            `$positive-scale5`,
            `$positive-scale6`,
            `$positive-scale7`,
            `$positive-scale8`,
          ],
          [
            `$negative-scale0`,
            `$negative-scale1`,
            `$negative-scale2`,
            `$negative-scale3`,
            `$negative-scale4`,
            `$negative-scale5`,
            `$negative-scale6`,
            `$negative-scale7`,
            `$negative-scale8`,
          ],
        ])}
      </SubSection>
    </Section>
  );
}
